import React from 'react';
import './Nouveaute.css';
import {NOUVEAUTES} from './data' ;

function Nouveaute() {
  return (
    <div className='messageriebox'>
        
      <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Nouveautés</p>
      <hr/> 

      <div className='containernouveautes'>
        {NOUVEAUTES.map((item) => ( 
          <div className='containernouveaute'>
            <p className='titlemsg'>{item.title}</p>
            <p>Date de création : <span>{item.date}</span> | Ecrit par : <span>{item.ecrivain}</span></p>
            <div className='containerliresuite'>
              <p>Lire la suite ...</p>
            </div>
          </div>
        ))}

       

      </div>

    </div>
      )
}

export default Nouveaute